import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './CustomInputAutocomplete.module.scss'
import Autosuggest from 'react-autosuggest'
import MediaQuery from 'react-responsive'
import CloseIcon from '../../components/customIcons/Close'
import { orderBy } from 'lodash'

class CustomInputAutocomplete extends Component {
    constructor(props) {
        super(props)
        this.state = {
            value: this.props.value || '',
            suggestions: [],
            places: [],
        }
        this.clearCustomInputAutocomplete = this.clearCustomInputAutocomplete.bind(
            this
        )
        this.getSuggestionValue = this.getSuggestionValue.bind(this)
        this.renderInputComponent = this.renderInputComponent.bind(this)
        this.renderSuggestion = this.renderSuggestion.bind(this)
    }

    getSuggestionValue = suggestion => suggestion[this.props.iterKey]

    renderSuggestion = suggestion => (
        <span>{suggestion[this.props.iterKey]}</span>
    )

    renderInputComponent = inputProps => (
        <div
            className={`${styles.mainSearchInputWrapper} ${
                this.props.mainSearchInputWrapper &&
                this.props.mainSearchInputWrapper
            }`}
        >
            <input
                {...inputProps}
                className={`${styles.mainSearchInput} ${
                    this.props.mainSearchInput && this.props.mainSearchInput
                }`}
            />
        </div>
    )
    onChange = (event, { newValue }) => {
        this.setState({
            value: newValue,
        })
    }

    clickEnter = event => {
        if (event.iterKey === 'Enter') {
            if (this.state.suggestions.length > 0) {
                this.setState(
                    {
                        value: this.state.suggestions[0][this.props.iterKey],
                    },
                    () => {
                        this.props.onEnter({
                            [this.props.iterKey]: this.state.value,
                        })
                    }
                )
            } else {
                this.setState({ value: '' })
                this.props.onEnter()
            }
        }
    }

    clearCustomInputAutocomplete() {
        window.sessionStorage.setItem(
            'sessionFilter',
            JSON.stringify({ city: '' })
        )
        this.setState(
            {
                value: '',
            },
            () => {
                if (this.props.onEnter)
                    this.props.onEnter({
                        startTime: '',
                        endTime: '',
                        professions: [],
                        nearbyPlace: {},
                        service: {},
                        price: [],
                    })
            }
        )
    }

    onSuggestionsFetchRequested = ({ value }) => {
        this.setState({
            suggestions: this.getSuggestions(value),
        })
    }

    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: [],
        })
    }

    getSuggestions = value => {
        let places = []
        this.props.iterable.forEach(item => {
            if (
                !places.filter(
                    place =>
                        place[this.props.iterKey] === item[this.props.iterKey]
                ).length
            )
                places.push({ [this.props.iterKey]: item[this.props.iterKey] })
        })

        const inputValue = value.trim().toLowerCase()
        const inputLength = inputValue.length

        return inputLength === 0
            ? orderBy(places, ['city'], ['asc'])
            : orderBy(
                  places.filter(place => {
                      return place[this.props.iterKey]
                          .toLowerCase()
                          .includes(inputValue)
                  }),
                  ['city'],
                  ['asc']
              )
    }

    onSuggestionSelected = (event, { suggestion, suggestionValue }) => {
        this.props.onEnter
            ? this.props.onEnter({ [this.props.iterKey]: suggestionValue })
            : this.props.form.setFieldValue(this.props.iterKey, suggestionValue)
    }

    shouldRenderSuggestions = val => {
        return true
    }

    render() {
        const { t } = this.props
        const { value, suggestions } = this.state

        const inputProps = {
            placeholder: t('generic_search'),
            value,
            onChange: this.onChange,
            onKeyDown: this.clickEnter,
            tabIndex: 1,
        }

        return (
            <div
                className={`${styles.mainSearchWrapper} ${
                    this.props.customWrapperClass &&
                    this.props.customWrapperClass
                }`}
            >
                <div
                    className={`${styles.label} ${
                        this.props.customLabelClass &&
                        this.props.customLabelClass
                    }`}
                >
                    {this.props.field?.label || this.props.label}
                </div>
                <Autosuggest
                    theme={this.props.theme}
                    suggestions={suggestions}
                    onSuggestionsFetchRequested={
                        this.onSuggestionsFetchRequested
                    }
                    onSuggestionsClearRequested={
                        this.onSuggestionsClearRequested
                    }
                    shouldRenderSuggestions={this.shouldRenderSuggestions}
                    onSuggestionSelected={this.onSuggestionSelected}
                    getSuggestionValue={this.getSuggestionValue}
                    renderInputComponent={this.renderInputComponent}
                    renderSuggestion={this.renderSuggestion}
                    inputProps={inputProps}
                    highlightFirstSuggestion
                    focusInputOnSuggestionClick={true}
                />
                {this.state.value !== '' && (
                    <div
                        className={`${styles.clearBtn} ${
                            this.props.customClearBtnClass &&
                            this.props.customClearBtnClass
                        }`}
                        onClick={this.clearCustomInputAutocomplete}
                    >
                        <MediaQuery minDeviceWidth={769}>
                            {t('reset')}
                        </MediaQuery>
                        <MediaQuery maxDeviceWidth={768}>
                            <CloseIcon className={styles.icon} />
                        </MediaQuery>
                    </div>
                )}
            </div>
        )
    }
}

export default withTranslation()(CustomInputAutocomplete)
